import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Home from "./components/Home";
import Footer from "./components/Footer";
import { Helmet } from "react-helmet";
import "./style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      upadateLoad(false);
    }, 700);
  }, []);

  return (
    <Container>
      <Helmet>
        <title>Mohit Bidikar Portfolio</title>
        <meta name="description" content="Mohit Bidikar Portfolio" />
      </Helmet>
      <Preloader load={load} />
      <Home />
      <Footer />
    </Container>
  );
}

export default App;
